import { USERNAME } from 'mk2/helpers/api';

export const mail = '/mail/';
export const mailCompose = '/mail/compose/';
export const mailBox = `/mail/${USERNAME}/:folder(inbox|outbox|starred)/`;
export const mailDetail = '/mail/:id(\\d+)/';
export const mailDetailInFolder = '/mail/:folder(inbox|outbox|starred)/:id(\\d+)/';
